export default function usePlatformCheck() {
  const isQiWei = localStorage.getItem('platform') === 'qiwei' || window.platform === 'qw';

  return {
    isQiWei,
  };
}
